import { Navigate, Outlet } from 'react-router-dom';
import { ONBOARDING_ROUTES } from '../onboardingRoutes';

function getOnboardingRedirect() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return '/dashboard';
    const user = JSON.parse(raw);
    if (user?.onboarding_step && user.onboarding_step !== 'COMPLETED') {
      return ONBOARDING_ROUTES[user.onboarding_step] || '/company-registration';
    }
  } catch {
    // ignore malformed local user payload
  }
  return '/dashboard';
}

export function GuestLayout() {
  const token = localStorage.getItem('access_token');

  if (token) {
    return <Navigate to={getOnboardingRedirect()} replace />;
  }

  return <Outlet />;
}
